import type { ModelManifest, ModelPayload } from "../types/model";

async function readJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    throw new Error(`Could not load ${url}: ${response.status}`);
  }
  return (await response.json()) as T;
}

export async function loadModels(signal?: AbortSignal): Promise<ModelPayload> {
  const manifest = await readJson<ModelManifest>("/data/manifest.json", {
    cache: "no-cache",
    signal
  });
  const payload = await readJson<ModelPayload>(`/data/${manifest.file}`, {
    cache: "force-cache",
    signal
  });

  if (
    payload.schemaVersion !== manifest.schemaVersion ||
    payload.dataVersion !== manifest.dataVersion ||
    payload.records.length !== manifest.recordCount ||
    payload.modelGroups.length !== manifest.modelGroupCount ||
    payload.platformUsageRules.length !== manifest.platformUsageRuleCount
  ) {
    throw new Error("The model data manifest does not match its snapshot.");
  }
  return payload;
}
